import { FC } from "react";
import { Stack } from "@mantine/core";

import {
  CreateTicketCheckbox,
  CreateTicketCheckboxProps,
} from "./CreateTicketCheckbox/CreateTicketCheckbox";
import { AddCommentsFormComponent } from "./AddCommentsFormComponent";

interface TriageActionsProps extends CreateTicketCheckboxProps {
  note: string;
  setNote: (e: any) => void;
}

export const TriageActionsComponent: FC<TriageActionsProps> = ({
  note,
  setNote,
  ...createTicketProps
}) => {
  return (
    <Stack gap={8}>
      <AddCommentsFormComponent
        note={note}
        setNote={setNote}
        placeholderText="Notes about what you've determined so far in your review"
      />
      <CreateTicketCheckbox {...createTicketProps} />
    </Stack>
  );
};
